import React from 'react'
import { useTranslation } from 'react-i18next'

const LanguageSelect = () => {
  const { i18n } = useTranslation()
  return (
    <>
      <label className="text-gray-600 mt-3 block text-h1 font-bold">Language</label>
      <select
        className="mt-2 w-full rounded-lg"
        onChange={(e) => {
          i18n.changeLanguage(e.target.value)
        }}
        defaultValue={i18n.language}
      >
        <option value="ja">日本語</option>
        <option value="en">English</option>
      </select>
    </>
  )
}

export default LanguageSelect
